import React from 'react'
import { Modal } from 'react-bootstrap'

export default class formInput extends React.Component {
    render() {
        const { changeHandler, saveHandler, Model, ShowModal, CreateHandler, EditHandler, CancelHandler, Mode, errors, ListBlood, ListCostumer_Relation } = this.props

        return (
            <div>
                <Modal show={ShowModal} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="mb-3">
                            <label for="nama" class="form-label">Nama Lengkap*</label>
                            <input type="txt" class="form-control" id="nama" value={Model.fullname} onChange={changeHandler("fullname")} />
                            <span class="error">{errors["nama"]}</span> <br />

                            <label for="tanggal_lahir" class="form-label">Tanggal Lahir*</label>
                            <input type="date" class="form-control" id="tanggal_lahir" value={Model.dob} onChange={changeHandler("dob")} />
                            <span class="error">{errors["tanggal_lahir"]}</span> <br />

                            <div class="form-group row">
                                <label class="ml-3 col-form-label mr-4">Jenis Kelamin*</label>

                                <div class="mt-2 ml-5">

                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input ml-5" type="radio" name="gender" id="gender_male" value="Pria" checked={Model.gender === "Pria"} onClick={changeHandler("gender")} />
                                        <label class="form-check-label" for="gender_male">
                                            Pria
										</label>
                                    </div>

                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input ml-5" type="radio" name="gender" id="gender_female" value="Wanita" checked={Model.gender === "Wanita"} onClick={changeHandler("gender")} />
                                        <label class="form-check-label" for="gender_female">
                                            Wanita
										</label>
                                    </div>
                                    <br />

                                </div>
                                <p class="error ml-3">{errors["gender"]}</p>

                                <div >
                                    <label class="ml-3 col-form-label">Golongan Darah / Rhesus</label>

                                    <div class="row">

                                        <div class=" ml-5 mr-4">
                                            <select class="form-control btn-outline" value={Model.blood_group_id} onChange={changeHandler("blood_group_id")}>
                                                <option selected hidden>--Pilih--</option>
                                                {
                                                    ListBlood.map(data => {
                                                        return (
                                                            <option value={data._id}>{data.code}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>

                                        <div class="ml-4 mt-2">
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input ml-5" type="radio" name="rh" id="rh+" value="Rh +" checked={Model.rhesus_type === "Rh +"} onClick={changeHandler("rhesus_type")} />
                                                <label class="form-check-label" for="rh+">
                                                    Rh +
										        </label>
                                            </div>

                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input ml-5" type="radio" name="rh" id="rh-" value="Rh -" checked={Model.rhesus_type === "Rh -"} onClick={changeHandler("rhesus_type")} />
                                                <label class="form-check-label" for="rh-">
                                                    Rh -
										        </label>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                                <div class="row mt-3 ml-1">

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Berat Badan (kg):</label>
                                            <input type="text" class="form-control" value={Model.weight} onChange={changeHandler("weight")} />
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Tinggi Badan (cm):</label>
                                            <input type="text" class="form-control" value={Model.height} onChange={changeHandler("height")} />
                                        </div>
                                    </div>


                                </div>

                                

                                <div class="col-md-11">
                                <label for="relasi ml-3">Relasi* </label>
                                    <select class="form-control" id="relasi" value={Model.customer_relation_id} onChange={changeHandler("customer_relation_id")}>
                                        <option selected hidden>--Pilih--</option>
                                        {
                                            ListCostumer_Relation.map(data => {
                                                return (
                                                    <option value={data._id}>{data.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <p class="error ml-3">{errors["customer_relation_id"]}</p>


                            </div>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={CancelHandler}>Batal</button>
                        <button type="button" class="btn btn-primary" onClick={saveHandler}>Simpan</button>
                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}